import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBSchoolVisibility = Database["public"]["Enums"]["school_visibility"];

export const SchoolVisibility = {
	PUBLIC: "public",
	PRIVATE: "private",
} as const satisfies Record<string, DBSchoolVisibility>;

export type SchoolVisibility = (typeof SchoolVisibility)[keyof typeof SchoolVisibility];

type _EnsureAllDBValues = Exclude<DBSchoolVisibility, SchoolVisibility> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const SCHOOL_VISIBILITIES = Object.values(SchoolVisibility) as readonly SchoolVisibility[];

export const schoolVisibilitySchema = z.enum(SchoolVisibility);
